import MuiMenu, { type MenuProps } from "@mui/material/Menu";
import MuiMenuList, { type MenuListProps } from "@mui/material/MenuList";

export type { MenuProps, MenuListProps };

export function Menu(props: MenuProps) {
  return <MuiMenu {...props} />;
}

export function MenuList(props: MenuListProps) {
  return <MuiMenuList {...props} />;
}
